// extracted by mini-css-extract-plugin
export var layoutContainer = "_5b-0";
export var layoutContainerNoRounding = "_5b-6";
export var layoutContainerOpen = "_5b-5";
export var layoutContainerResizing = "_5b-1";
export var mainContent = "_5b-2";
export var resizeDivider = "_5b-3";
export var slidePanel = "_5b-4";